import { Component } from "solid-js";

interface FashionIconProps {
  class?: string;
}

export const FashionIcon: Component<FashionIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M16.8893 9.18232L20.0701 10.2426C20.769 10.4755 21.5244 10.0978 21.7574 9.39895L22.6695 6.66271L20.7831 4.77631C20.2828 4.276 19.6042 3.99493 18.8966 3.99493H13.1034C12.3958 3.99493 11.7173 4.276 11.217 4.77631L9.33057 6.66271L10.2426 9.39895C10.4756 10.0978 11.231 10.4755 11.9299 10.2427L15.1107 9.18232"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 10.6644V29.3388"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.9867 15.9999L23.9869 26.0616C24.0001 27.2594 23.2033 28.3152 22.0478 28.6311C18.0599 29.5747 13.9069 29.5747 9.91897 28.6311C8.76347 28.3152 7.96669 27.2594 7.9799 26.0616L7.98004 15.9999"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33019 6.66278L6.63949 7.55967C5.81738 7.83371 5.17961 8.48998 4.92917 9.31958L2.8888 16.0786C2.63987 16.9032 2.59428 17.7758 2.75593 18.6218L3.83194 24.2537C3.95208 24.8825 4.50199 25.3372 5.14217 25.3372H7.9963"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.6699 6.66278L25.3606 7.55967C26.1827 7.83371 26.8205 8.48998 27.0709 9.31958L29.1113 16.0786C29.3602 16.9032 29.4058 17.7758 29.2442 18.6218L28.1682 24.2537C28.048 24.8825 27.4981 25.3372 26.8579 25.3372H24.0038"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.1038 4.16968L16 10.6644L19.8963 4.16968"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
